export default __webpack_public_path__ + "static/media/walvisKlein.b8357af9.jpg";